import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Checkbox } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import DeleteIcon from "@mui/icons-material/Delete";
import { formatCurrency2Digit } from "utils/helpers/format";

const useColumns = (
  setViewProduct,
  setProduct,
  handleViewOpen,
  handleModalOpen,
  DeleteOrder
) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState({});
  const [activeRowId, setActiveRowId] = useState(null);

  const handleMenuOpen = (event, id) => {
    setAnchorEl(event.currentTarget);
    setActiveRowId(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveRowId(null);
  };

  const handleCheckboxChange = (id) => {
    setSelected((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const columns = [
    {
      Header: "",
      accessor: "checkbox",
      width: "50px",
      disableSortBy: true,
      Cell: ({ row }) => (
        <Checkbox
          checked={selected[row.values.id] || false}
          onChange={() => handleCheckboxChange(row.values.id)}
        />
      ),
    },
    {
      Header: "",
      accessor: "expand",
      width: "100px",
      disableSortBy: true,
      Cell: ({ row }) =>
        row.values.actions ? (
          <IconButton onClick={() => row.toggleRowExpanded()}>
            <ExpandMoreIcon />
          </IconButton>
        ) : null,
    },
    {
      Header: "รูปภาพ",
      accessor: "picture",
      disableSortBy: true,
    },
    { Header: "รหัสรายการ", accessor: "order_code", showInFilter: true },
    { Header: "เลขบัตรประชาชน", accessor: "idcard", showInFilter: true },
    { Header: "ชื่อ-สกุล", accessor: "customer_name", showInFilter: true },
    {
      Header: "จำนวนเงิน",
      accessor: "total_price",
      showInFilter: false,
      Cell: ({ row }) => (
        <span>{formatCurrency2Digit(row?.total_price || 0)}</span>
      ),
    },
    {
      Header: "วันที่ทำรายการ",
      accessor: "created_date",
      showInFilter: true,
      type: "datepicker",
    },
    { Header: "สถานะ", accessor: "order_status", showInFilter: false },
    { Header: "ประเภท", accessor: "product_type", showInFilter: false },
    {
      Header: "Actions",
      accessor: "actions",
      disableSortBy: true,
      Cell: ({ row }) => {
        console.log("Row data:", row);
        return (
          <div>
            <IconButton onClick={(event) => handleMenuOpen(event, row.id)}>
              <MoreVertIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl) && activeRowId === row.id}
              onClose={handleMenuClose}
            >
              <MenuItem
                onClick={() => {
                  setViewProduct(row);
                  handleViewOpen();
                  handleMenuClose();
                }}
              >
                <RemoveRedEyeIcon
                  style={{ marginRight: "8px", color: "#737373" }}
                />
                <span style={{ marginLeft: "8px", color: "#737373" }}>
                  ดูรายละเอียด
                </span>
              </MenuItem>
              {/* Render "View Details" option only if orderStatus is 1 */}
              <MenuItem
                onClick={() => {
                  // Uncomment and add logic for printing if needed
                  // console.log("Print action for product ID:", row.original.id);
                  handleMenuClose();
                }}
              >
                <LocalPrintshopIcon
                  style={{ marginRight: "8px", color: "#737373" }}
                />
                <span style={{ marginLeft: "8px", color: "#737373" }}>
                  พิมพ์
                </span>
              </MenuItem>
              {row.order_status !== 4 && row.order_status !== 2 && (
                <MenuItem
                  onClick={() => {
                    // Uncomment and add logic for printing if needed
                    // console.log("Print action for product ID:", row.original.id);
                    handleMenuClose();
                    DeleteOrder(row.id);
                  }}
                >
                  <DeleteIcon
                    style={{ marginRight: "8px", color: "#737373" }}
                  />
                  <span style={{ marginLeft: "8px", color: "#737373" }}>
                    ย้ายไปถังขยะ
                  </span>
                </MenuItem>
              )}
            </Menu>
          </div>
        );
      },
    },
  ];
  return columns;
};

export default useColumns;
